import React from 'react';
import './notificationDeliveryTestLabel.module.scss';

export const NotificationDeliveryTestLabel = () => {
    return <div styleName="test-label">テスト配信</div>;
};
